import { Component, OnInit } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { EconomyService, SalaryTypeItem } from '@app/services/economy.service';
import { LogisticService, UnitItem } from '@app/services/logistic.service';
import { ExtraQuantityTypeItem, SalaryTypeGet, SalaryTypeService } from '@app/services/salary-type.service';
import { TypeaheadService } from '@app/services/typeahead.service';

@Component({
    selector: 'tt-salary-type',
    templateUrl: './salary-type.component.html',
    styleUrls: ['./salary-type.component.css'],
    standalone: false
})
export class SalaryTypeComponent implements OnInit {
    public salaryTypeId = '';

    public page?: SalaryTypeGet;

    public salaryTypes: SalaryTypeItem[] = [];

    public units: UnitItem[] = [];

    public impactTimeAccounts: Item[] = [];

    public extraQuantityTypes: ExtraQuantityTypeItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(
        private readonly salaryType: SalaryTypeService,
        private readonly economy: EconomyService,
        private readonly logistic: LogisticService,
        private readonly typeahead: TypeaheadService,
        private readonly modal: ModalService,
        private readonly state: StateService,
    ) {}

    public async ngOnInit(): Promise<void> {
        this.salaryTypeId = this.state.getStateParams()['salarytype_id'] ?? '';

        const [page, salaryTypes, units, impactTimeAccounts, extraQuantityTypes] = await Promise.all([
            this.salaryType.getSalaryType({ salarytype_id: this.salaryTypeId }),
            this.economy.getSalaryTypes(),
            this.logistic.getUnitList({}),
            this.salaryType.getImpactTimeAccounts(),
            this.salaryType.getExtraQuantityTypes()
        ]);

        this.page = page;
        this.salaryTypes = salaryTypes;
        this.units = units;
        this.impactTimeAccounts = impactTimeAccounts;
        this.extraQuantityTypes = extraQuantityTypes;
    }

    public searchProducts = () => this.typeahead.lookUpProducts({ prod_name: this.page?.prod_name ?? '' });

    public onProductSelected(item?: Item): void {
        if (!this.page) return;

        this.page.prod_id = item?.item_id == null ? '' : String(item.item_id);
        this.page.prod_name = item?.item_name ?? '';
    }

    public async saveChanges(): Promise<void> {
        if (!this.page) return;

        this.saving = true;

        if (this.page.overtime === '0') this.page.extrapst = '0';

        if (this.page.absence === '0') {
            this.page.absence_paid = '0';
            this.page.absence_legal = '0';
        }

        try {
            const response = await this.salaryType.saveSalaryType(this.page);

            if (String(response?.status_no) !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response?.status_message ?? ''
                });
            } else {
                this.state.back();
            }
        } finally {
            this.saving = false;
        }
    }

    public async deleteValues(): Promise<void> {
        if (!this.page) return;

        this.deleting = true;

        try {
            const confirmed = await this.modal.openConfirmDialog({
                type: 'danger',
                title: 'confirm_title',
                translateTitle: true,
                message: 'confirm_message',
                translateMessage: true,
                ok: 'confirm_ok_label',
                cancel: 'confirm_cancel_label'
            });

            if (!confirmed) return;

            const response = await this.salaryType.deleteSalaryType({ salarytype_id: this.page.salarytype_id });

            if (String(response?.status_no) !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response?.status_message ?? ''
                });
            } else {
                this.state.back();
            }
        } finally {
            this.deleting = false;
        }
    }
}
